module.exports = __webpack_public_path__ + "img/image_16.f77a11b5.png";